// extracted by mini-css-extract-plugin
export default {"shipping_left":"HelpCenterSidebar_shipping_left__pWoIQ"};